"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const IMAGES = {
    airWing: 'https://images.unsplash.com/photo-1493988577905-2fa4018652be?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1351&q=80',
    blossom: 'https://images.unsplash.com/photo-1497744133860-11bff6c0f288?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=996&q=80',
    bodyOfWaterOnIce: 'https://images.unsplash.com/photo-1463595709917-93fb36118407?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
    broad: 'https://images.unsplash.com/photo-1491958501121-458097ef59ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1353&q=80',
    clouds: 'https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    crow: 'https://images.unsplash.com/photo-1517249865690-ee36eb09e596?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    doorsOpen: 'https://images.unsplash.com/photo-1481277542470-605612bd2d61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1295&q=80',
    forest: 'https://images.unsplash.com/photo-1484977975800-86a4c7bd7235?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    inifiteDogWalk: 'https://images.unsplash.com/photo-1517598499378-be07cbf2e1d0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=701&q=80',
    lemons: 'https://images.unsplash.com/photo-1454944338482-a69bb95894af?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1504&q=80',
    manOnWater: 'https://images.unsplash.com/photo-1531414220929-ca8e4dde058f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80',
    micMan: 'https://images.unsplash.com/photo-1469050624972-f03b8678e363?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
    mount: 'https://images.unsplash.com/photo-1490131784822-b4626a8ec96a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    peakAtTrees: 'https://images.unsplash.com/photo-1519120944692-1a8d8cfc107f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=676&q=80',
    sandAndMountains: 'https://images.unsplash.com/photo-1465217787303-8f029c50d092?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
    stairs: 'https://images.unsplash.com/photo-1496517463163-3550265405c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80',
};
const i = lodash_1.random(Object.keys(IMAGES).length - 1);
const img = Object.values(IMAGES)[i];
class HomeCard extends react_1.default.Component {
    renderBadge(count, resource) {
        return (react_1.default.createElement("p", { style: {
                fontSize: 13,
                marginBottom: 2,
                marginTop: 5,
                opacity: 0.6,
            } },
            count || 0,
            " ",
            resource,
            count !== 1 && 's'));
    }
    // public async getPhoto() {
    //   const resp = await axios.request({
    //     method: 'get',
    //     params: {
    //       maxRecords: 3,
    //       view: 'Grid view',
    //     },
    //     url:
    //       'https://api.airtable.com/v0/app3StzM04iIVQJzz/Photos?maxRecords=3&view=Grid%20view',
    //   });
    //   this.setState({
    //     photo: resp,
    //   });
    // }
    render() {
        const { url, name, icon, count, right, btnText, featured, description, resourceName, flexGrow, style, } = this.props;
        const Logo = icon;
        // const colProps =
        //   featured === true ? { xs: 12, md: 12, xl: 12 } : { xs: 12, md: 6, xl: 3 };
        const button = (react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Button, { className: featured ? 'mt-2' : 'p-0', color: featured ? 'primary' : 'link' },
                btnText || 'Open',
                " ",
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowRight }))));
        const rightInner = right && (react_1.default.createElement("div", { className: "d-flex flex-row justify-content-end h-100" },
            react_1.default.createElement("div", { className: "flex-grow-1 h-100 d-flex justify-content-center" }, right)));
        const showBg = false && name === 'Osmosys Emails' && img;
        return (react_1.default.createElement(reactstrap_1.Col, { tag: react_2.OsmosysDiv, "data-resource-name": resourceName, osysName: "HomeCard", className: classnames_1.default(flexGrow !== false ? 'flex-grow-1' : 'flex-grow-0', 'd-flex mb-3 mb-md-4'), style: style, xs: 12, sm: featured ? 12 : 6, 
            // md={featured ? 12 : 6}
            // lg={featured ? 12 : 6}
            xl: featured ? 12 : 3 },
            react_1.default.createElement(reactstrap_1.Card, { body: true, className: "flex-grow-1 d-flex flex-column justify-content-between p-0 shadow-sm overflow-hidden" },
                react_1.default.createElement("div", { className: "flex-grow-1 d-flex flex-row text-reset justify-content-center p-3 p-md-4 " },
                    react_1.default.createElement(react_router_dom_1.Link, { to: url, className: "flex-grow-1 flex-col-centered position-relative text-reset", style: showBg
                            ? {
                                backgroundImage: `url(${img})`,
                                backgroundPosition: '50% 70%',
                                backgroundSize: 'cover',
                            }
                            : {} },
                        react_1.default.createElement("div", { className: "d-flex flex-grow-1 flex-column", style: {
                                zIndex: 10,
                            } },
                            react_1.default.createElement("div", { className: "flex-grow-1" },
                                react_1.default.createElement(Logo, { width: "64", height: "64", className: "mb-2" }),
                                featured ? react_1.default.createElement("h2", null, name) : react_1.default.createElement("h3", null, name),
                                react_1.default.createElement("p", { className: classnames_1.default('mb-0', { lead: featured }) }, description)),
                            react_1.default.createElement("div", { className: "align-self-end mt-2 d-flex flex-row justify-content-between w-100" },
                                resourceName && (react_1.default.createElement("div", null,
                                    this.renderBadge(count || 0, resourceName),
                                    !!featured && button)),
                                !featured && button)),
                        showBg && (react_1.default.createElement("div", { className: "position-absolute bg-white", style: {
                                bottom: 0,
                                left: 0,
                                opacity: 0.8,
                                right: 0,
                                top: 0,
                            } }))),
                    true && react_1.default.createElement("div", { className: "p-2" }, rightInner))),
            false && rightInner && (react_1.default.createElement(reactstrap_1.Card, { body: true, style: { maxWidth: '45%' }, className: "flex-grow-0 ml-4 d-none d-md-flex flex-row p-3 p-md-4 shadow-sm" }, rightInner))));
    }
}
exports.HomeCard = HomeCard;
//# sourceMappingURL=HomeCard.js.map